<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-filter"></template>
        <template slot="table-body">
            <cot-pua-list-component ref="CotPuaListComponent" @afterLoadData="onAfterLoadData"></cot-pua-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import CotPuaListComponent from "../components/CotPuaListComponent.vue";
export default {
    components: { SaPageLayout, CotPuaListComponent },
    data() {
        return {
            showModalLoading: false,
            btnNewVisible: true,
            btnRefreshVisible: true,
            pathResource: null,
            linkedit: "pua",
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.CotPuaListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
